const general = {
  name: function(value, attributes, attributeName, options, constraints) {
    return {
      presence: {
        allowEmpty: !attributes._name.required,
        message: "Nome é obrigatório"
      }
    };
  },
  email: function(value, attributes, attributeName, options, constraints) {
    if (value === null && attributes._email.required) {
      return {
        email: {
          message: "E-mail com formato inválido"
        },
        presence: {
          allowEmpty: false,
          message: "E-mail é obrigatório"
        }
      };
    } else {
      return {
        email: {
          message: "E-mail com formato inválido"
        }
      };
    }
  },
  phone: function(value, attributes, attributeName, options, constraints) {
    if (value === null && attributes._phone.required) {
      return {
        format: {
          pattern: /^\d{8,11}$|^$/,
          message: "Telefone com formato inválido"
        },
        presence: {
          allowEmpty: false,
          message: "Telefone é obrigatório"
        }
      };
    } else {
      return {
        format: {
          pattern: /^\d{8,11}$|^$/,
          message: "Telefone com formato inválido"
        }
      };
    }
  },
  birth_date: function(value, attributes, attributeName, options, constraints) {
    return {
      simpleDate: {
        allowEmpty: true,
        message: "Data de nascimento com formato inválido"
      },
      presence: {
        allowEmpty: !attributes._birth_date.required,
        message: "Data de Nascimento é obrigatória"
      }
    };
  },
  identification: function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (!attributes.identification && attributes._identification.required) {
      return {
        presence: {
          allowEmpty: false,
          message: "Identificação é obrigatória"
        }
      };
    } else if (
      attributes.identification.length > 0 &&
      attributes.identification.length < 11
    ) {
      return {
        cpf: { message: "Identificador com formato inválido" }
      };
    } else {
      if (attributes.identification.length === 11) {
        return {
          cpf: { message: "CPF é inválido" }
        };
      } else if (attributes.identification.length === 14) {
        return {
          cnpj: { message: "CNPJ é inválido" }
        };
      } else {
        return {};
      }
    }
  },
  notes: function(value, attributes, attributeName, options, constraints) {
    return {
      presence: {
        allowEmpty: !attributes._notes.required,
        message: "Observação é obrigatória"
      }
    };
  },
  "address.zipcode": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    return {
      format: {
        pattern: /^\d{8}$|^$/,
        message: "CEP com formato inválido"
      },
      presence: {
        allowEmpty: !attributes._zipcode.required,
        message: "CEP é obrigatório"
      }
    };
  },
  "address.state": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    return {
      format: {
        pattern: /^RO|AC|AM|RR|PA|AP|TO|MA|PI|CE|RN|PB|PE|AL|SE|BA|MG|ES|RJ|SP|PR|SC|RS|MS|MT|GO|DF|$/,
        message: "Estado inválido"
      },
      presence: {
        allowEmpty: !attributes._state.required,
        message: "Estado é obrigatório"
      }
    };
  },
  "address.city": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    return {
      presence: {
        allowEmpty: !attributes._city.required,
        message: "Cidade é obrigatório"
      }
    };
  },
  "address.neighborhood": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    return {
      presence: {
        allowEmpty: !attributes._neighborhood.required,
        message: "Bairro é obrigatório"
      }
    };
  },
  "address.street": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    return {
      presence: {
        allowEmpty: !attributes._street.required,
        message: "Lagradouro é obrigatório"
      }
    };
  },
  "address.number": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    return {
      presence: {
        allowEmpty: !attributes._number.required,
        message: "Número é obrigatório"
      }
    };
  },
  "address.complement": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    return {
      presence: {
        allowEmpty: !attributes._complement.required,
        message: "Complemento é obrigatório"
      }
    };
  }
};

export default {
  general
};



// WEBPACK FOOTER //
// ./src/core/constraint/customer.constraint.js